import React, {useEffect, useState} from 'react';
import {
    getBackgroundImg,
    getPublicImagePath, getUploadedImagePath,
    MarkupRender,
    useAppDispatch,
    useAppState
} from '@nutastic/nutastic-react-app';
import YoutubeVideoPlayer from "../YoutubeVideoPlayer";
import classnames from "classnames";
import {useParams} from "react-router-dom";
import {useNavigation} from "../../hooks/useNavigation";
import Href from "../Href";
import {WebsiteActions} from "../../state/actions.mjs";
import ContentNotFoundPage from "./ContentNotFoundPage";

const componentClass = 'contentPage';

const ContentVideoPage = () => {
    const classes = classnames(componentClass, 'useVideoPageStyles');
    const appDispatch = useAppDispatch();
    const {
        isProcessing,
        content: {
            videos = []
        }
    } = useAppState();
    const { id: videoSlug } = useParams();
    const [ currentVideo, setCurrentVideo ] = useState(null);

    const {
        title,
        image,
        content: videoUri,
        excerpt: subtitle,
        field_2: description
    } = currentVideo || {};

    useEffect(() => {
        appDispatch({ type: WebsiteActions.REUP_STARTED });
        setCurrentVideo(null);
        const matchedVideo = videos.find(v => v?.slug === videoSlug);
        if (matchedVideo) {
            setCurrentVideo(matchedVideo);
        }
        setTimeout(() => {
            appDispatch({ type: WebsiteActions.REUP_DONE });
        }, 1000);
    }, [videoSlug])

    return (!isProcessing && !!currentVideo) ? <article className={classes}>
        <div className={`${componentClass}__videoBanner`} style={getBackgroundImg(getUploadedImagePath(image))}>
            <span />
        </div>
        <div className={`${componentClass}__wideContent`}>
            <div className={`${componentClass}__videoHeader`}>
                <h1>{ title }</h1>
                <p>{ subtitle }</p>
            </div>
            <YoutubeVideoPlayer videoUrl={videoUri} />
            <div className={`${componentClass}__videoDetails`}>
                <MarkupRender tagName="p" content={description} />
            </div>
        </div>
    </article> : <ContentNotFoundPage isProcessing={isProcessing} />;
};

export default ContentVideoPage;
